export function truncate(str, len) {
    if (!str) return '';
    return str.length > len ? str.substring(0, len) + '…' : str;
}

export function fmtAmt(value, currency = 'EUR') {
    const num = parseFloat(value);
    if (isNaN(num)) return '-';
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(num);
}

export function hasDiff(a, b) {
    if (!a && !b) return false;
    return String(a || '').trim() !== String(b || '').trim();
}

export function hasDiffDate(a, b) {
    const normalize = v => {
        if (!v) return '';
        const s = String(v).trim();
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
            const [d, m, y] = s.split('/');
            return `${y}-${m}-${d}`;
        }
        return s;
    };
    const na = normalize(a), nb = normalize(b);
    if (!na && !nb) return false;
    return na !== nb;
}

export function hasDiffAmt(a, b) {
    return Math.abs((parseFloat(a) || 0) - (parseFloat(b) || 0)) > 0.005;
}

export function normalizeDateForInput(value) {
    if (!value) return '';
    const s = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
        const [d, m, y] = s.split('/');
        return `${y}-${m}-${d}`;
    }
    return '';
}

export function confidenceLabel(confidence) {
    const labels = { high: 'Élevée', medium: 'Moyenne', low: 'Faible' };
    return labels[confidence] || confidence;
}

export function confidenceClass(confidence) {
    const classes = { high: 'green', medium: 'orange', low: 'red' };
    return classes[confidence] || '';
}
